module.exports = __webpack_public_path__ + "img/gradient-background.70ee9126.png";